import React from 'react'

const SeaFreight = () => {
  return (
    <div>SeaFreight</div>
  )
}

export default SeaFreight